import { defaultMemoize, createSelectorCreator } from 'reselect';
import createMetadataAPISelectors from '../../utils/api-metadata-selectors';
import { isEqual } from 'lodash';

const name = 'workingTimeDirectiveReports';
const defaultSelectors = createMetadataAPISelectors({ name });

const createDeepEqualSelector = createSelectorCreator(defaultMemoize, isEqual);

const rulesById = state => state[name].rulesById || {};

const rules = createDeepEqualSelector(rulesById, byId => Object.values(byId));

export default {
  ...defaultSelectors,
  rules
};
